import cn from 'clsx';
import React from 'react';

import { Body1, Heading1, Heading2, useDeviceType } from '@cian/ui-kit';

import styles from './styles.css';

export type TFeatureHighlightBulletSurface = 'neutral' | 'main';

export interface IFeatureHighlightItem {
  title: string;
  description: string;
  bullet: React.ReactNode;
}

interface IFeatureHighlightListProps {
  items: IFeatureHighlightItem[];
  bulletSurface?: TFeatureHighlightBulletSurface;
}

const renderTitleContent = (title: string, deviceType: ReturnType<typeof useDeviceType>) => {
  if (!title.includes('\n')) {
    return title;
  }

  const lines = title.split('\n');

  if (deviceType === 'phone') {
    return lines.join(' ');
  }

  return lines.map((line, index) => (
    <React.Fragment key={index}>
      {index > 0 ? <br /> : null}
      {line}
    </React.Fragment>
  ));
};

export const FeatureHighlightList: React.FC<IFeatureHighlightListProps> = ({ items, bulletSurface = 'neutral' }) => {
  const deviceType = useDeviceType();
  const ItemTitle = deviceType === 'desktop' ? Heading1 : Heading2;

  return (
    <div className={cn(styles['list'], styles[deviceType])}>
      {items.map((item, index) => (
        <div key={index} className={cn(styles['item'], styles[deviceType])}>
          <div className={cn(styles['bullet'], styles[deviceType], styles[`bullet--surface-${bulletSurface}`])}>
            {item.bullet}
          </div>
          <div className={cn(styles['text'], styles[deviceType])}>
            <ItemTitle fontWeight="700">{renderTitleContent(item.title, deviceType)}</ItemTitle>
            <Body1 color="text-secondary-default">{item.description}</Body1>
          </div>
        </div>
      ))}
    </div>
  );
};
